import { ActionsUnion, createAction } from '../../modules/helpers';
import { ISocketNotificationCounter, ISocketNotificationEvent } from './types';

export enum EWebsocketActionType {
  RECONNECT = 'WEBSOCKET/RECONNECT',
  EVENT_RECEIVED = 'WEBSOCKET/EVENT_RECEIVED',
  COUNTER_RECEIVED = 'WEBSOCKET/COUNTER_RECEIVED',
}

export const websocketActions = {
  reconnect: (noMaxRetry: boolean) =>
    createAction(EWebsocketActionType.RECONNECT, { noMaxRetry }),
  counterReceived: (notifications: ISocketNotificationCounter) =>
    createAction(EWebsocketActionType.COUNTER_RECEIVED, notifications),
  eventReceived: (notifications: ISocketNotificationEvent) =>
    createAction(EWebsocketActionType.EVENT_RECEIVED, notifications),
};

export type TWebsocketAction = ActionsUnion<typeof websocketActions>;
